<div class="widget-mobile">
  <div class="container">
    <div class="d-flex align-items-center pt-2">
      <!-- Back Button -->
      <div class="container p-0">
        <div class="d-none d-lg-block pt-3 mb-2">
          <div class="back-button" [routerLink]="'/rewards/wallet'">
            <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Offer history -->
    <ng-container *ngIf="campaignOffers$ | async as featuredCampaigns">
      <ng-container *ngIf="featuredCampaigns.CampaignsAndEntitlements?.length" class="pb-4">
        <h5 class="m-0 wallet-redeemed-title font-size-18 pb-3 pt-3">
          {{ 'wallet.redeemed.offers.history.title' | translate }}
        </h5>
        <fgbcl-campaigns-offers-used-list
          [usedOffers]="featuredCampaigns.CampaignsAndEntitlements"
        ></fgbcl-campaigns-offers-used-list>
      </ng-container>
    </ng-container>

    <!-- Items history -->
    <ng-container
      *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
    >
      <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
        <h5 class="m-0 wallet-redeemed-title font-size-18 pb-3 pt-3">
          {{ 'wallet.redeemed.item.history.title' | translate }}
        </h5>
        <fgbcl-rewards-wallet-redeemed-list
          [redeemedItems]="walletItems.walletItemsClaimed"
          [style]="'list'"
        ></fgbcl-rewards-wallet-redeemed-list>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #noWalletItems>
    <div class="container mt-3">
      <div class="border no-items-rounded bg-white border-disabled">
        <div class="fw-bold font-size-12 text-center py-3">
          {{ 'claimed.rewards.placeholder.description' | translate }}
        </div>
      </div>
    </div>
  </ng-template>
</div>
